<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-if="page === 'feedback'"
    class="page"
  >
    <Header
      :setting="{
        title: '意見回饋',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div class="fs4 fc--primary mb4">
      璟馨婦幼醫院
    </div>
    <div
      v-if="composable.member.os==='ios'"
      class="page__text ba--primary border-radius-1 pv3 ph2 mb4 align--left"
    >
      溫馨提醒：<br>
      <span class="fw4">
        ＊iOS 14.4 超音波影像無法正常運作，煩請更新作業系統。
      </span>
    </div>
    <div class="page__form mb8">
      <input
        v-model="feedbackForm.name"
        type="text"
        placeholder="聯絡大名(必填)"
        class="mb5"
      >
      <input
        v-model="feedbackForm.mobile"
        type="text"
        placeholder="聯絡電話(必填)"
        class="mb5"
      >
      <input
        v-model="feedbackForm.email"
        type="text"
        placeholder="電子信箱 E-mail(必填)"
        class="mb5"
      >
      <div class="pl3 align--left">
        意見回饋
      </div>
      <textarea v-model="feedbackForm.content" />
    </div>
    <div
      @click="sendFeedback"
      class="label label--primary mb5"
    >
      確定送出
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toHome="toHome"
  />
</template>

<script>
import { reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';

export default {
  setup() {
    const page = ref('initialization');
    const feedbackForm = reactive({
      name: '',
      mobile: '',
      email: '',
      content: '',
    });
    const router = useRouter();

    onMounted(async () => {
      try {
        if (composable.member.info.status === 'in') {
          feedbackForm.name = composable.member.info.name;
          feedbackForm.mobile = composable.member.info.mobile;
        }

        composable.loading.show('資料載入中');

        page.value = 'feedback';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    async function sendFeedback() {
      try {
        spiderman.form.verify(feedbackForm);

        composable.loading.show('傳送中，請稍候');

        const response = await api.feedback.send(
          composable.member, feedbackForm,
        );

        composable.modal.done(response.message);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function toHome() {
      composable.modal.close();
      router.push({ path: '/home' });
    }

    return {
      page,
      composable,
      feedbackForm,
      sendFeedback,
      toHome,
    };
  },
};
</script>
